import { render, staticRenderFns } from "./JpPress.vue?vue&type=template&id=59465750&"
import script from "./JpPress.vue?vue&type=script&lang=js&"
export * from "./JpPress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports